// extracted by mini-css-extract-plugin
export default {"link":"LinkButton_link__RJpsK"};